<template>
  <div id="homePage2" class="homepage-section">
    <div class="background-image">
      <img src="@/assets/img/homePage/13.png" :alt="$t('hp2.bgAlt')" />
    </div>

    <div class="content-container">
      <div class="support-section animate-on-scroll">
        <h3 class="section-subtitle">{{ $t("hp2.supportSubtitle") }}</h3>
        <h2 class="section-title">{{ $t("hp2.supportTitle") }}</h2>
        <p class="section-description">
          {{ $t("hp2.supportDesc1") }}
        </p>
        <p class="section-description">
          {{ $t("hp2.supportDesc2") }}
        </p>
      </div>

      <div class="scalability-section animate-on-scroll">
        <h2 class="section-title">{{ $t("hp2.scalabilityTitle") }}</h2>
        <div class="stats-grid">
          <div class="stat-item animate-on-scroll" data-delay="0">
            <div class="stat-number">{{ $t("hp2.stat1Number") }}</div>
            <div class="stat-description">
              {{ $t("hp2.stat1Desc") }}
            </div>
          </div>
          <div class="stat-item animate-on-scroll" data-delay="200">
            <div class="stat-number">{{ $t("hp2.stat2Number") }}</div>
            <div class="stat-description">
              {{ $t("hp2.stat2Desc") }}
            </div>
          </div>
          <div class="stat-item animate-on-scroll" data-delay="400">
            <div class="stat-number">{{ $t("hp2.stat3Number") }}</div>
            <div class="stat-description">
              {{ $t("hp2.stat3Desc") }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {}
  },
  mounted() {
    this.initScrollAnimations()
  },
  methods: {
    initScrollAnimations() {
      const observerOptions = {
        threshold: 0.1,
        rootMargin: "0px 0px -50px 0px",
      }

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const element = entry.target
            const delay = element.dataset.delay || 0

            setTimeout(() => {
              element.classList.add("animate-in")
            }, delay)

            observer.unobserve(element)
          }
        })
      }, observerOptions)

      const animatedElements = document.querySelectorAll(".animate-on-scroll")
      animatedElements.forEach((el) => observer.observe(el))
    },
  },
}
</script>

<style scoped>
.homepage-section {
  position: relative;
  min-height: 700px;
  background: none;
  overflow: hidden;
}

.background-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.background-image img {
  width: 100%;
  height: 100%;
  /* object-fit: cover; */
  opacity: 1;
}

.content-container {
  position: relative;
  z-index: 2;
  max-width: 1200px;
  margin: 0 auto;
  padding: 200px 20px 80px 20px;
  color: white;
}

.support-section {
  margin-bottom: 100px;
  text-align: left;
}

.section-subtitle {
  color: #5fb847;
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 16px;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.section-title {
  font-size: 40px;
  font-weight: 500;
  font-weight: bold;
  margin-bottom: 24px;
  line-height: 1.3;

  max-width: 700px;
}

.section-description {
  font-family: Arial;
  color: #b4b5b8;
  font-size: 18px;
  line-height: 1.8;
  margin-bottom: 16px;
  /* opacity: 0.9; */
  max-width: 400px;
}

.scalability-section {
  text-align: left;
}

.scalability-section .section-title {
  font-size: 40px;
  font-weight: 500;
  font-weight: bold;
  margin-bottom: 60px;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 40px;
}

.stat-item {
  text-align: left;
}

.stat-number {
  font-size: 32px;
  font-weight: 700;
  color: white;
  margin-bottom: 16px;
  line-height: 1.2;
}

.stat-number::before {
  content: "| ";
  color: #5fb847;
  font-weight: 700;
}

.stat-description {
  font-size: 16px;
  line-height: 1.6;
  color: white;
  opacity: 0.9;
}

.animate-on-scroll {
  opacity: 0;
  transform: translateY(30px);
  transition: all 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

.animate-on-scroll.animate-in {
  opacity: 1;
  transform: translateY(0);
}

.stat-item.animate-on-scroll {
  transform: translateY(40px) scale(0.95);
  transition: all 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

.stat-item.animate-on-scroll.animate-in {
  transform: translateY(0) scale(1);
}

.support-section.animate-on-scroll {
  transform: translateY(50px);
  transition: all 1s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

.support-section.animate-on-scroll.animate-in {
  transform: translateY(0);
}

.scalability-section.animate-on-scroll {
  transform: translateY(40px);
  transition: all 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

.scalability-section.animate-on-scroll.animate-in {
  transform: translateY(0);
}

/* RTL: right align content */
[dir="rtl"] .homepage-section .support-section,
[dir="rtl"] .homepage-section .scalability-section,
[dir="rtl"] .homepage-section .stat-item {
  text-align: right;
}
[dir="rtl"] .homepage-section .section-title {
  text-align: right;
}
[dir="rtl"] .homepage-section .stat-number::before {
  content: "";
}
[dir="rtl"] .homepage-section .stat-number::after {
  content: " |";
  color: #5fb847;
  font-weight: 700;
}

/* Keep support section left-aligned in RTL */
[dir="rtl"] .homepage-section .support-section {
  text-align: right;
}
[dir="rtl"] .homepage-section .support-section .section-title {
  text-align: right;
}

@media (max-width: 768px) {
  .content-container {
    padding: 60px 20px;
  }

  .section-subtitle {
    font-size: 16px;
    margin-bottom: 12px;
  }

  .section-title {
    font-size: 36px;
    margin-bottom: 20px;
    line-height: 1.4;
  }

  .scalability-section .section-title {
    font-size: 36px;
    margin-bottom: 50px;
  }

  .section-description {
    font-size: 17px;
    line-height: 1.9;
    margin-bottom: 14px;
  }

  .stats-grid {
    grid-template-columns: 1fr;
    gap: 35px;
  }

  .stat-number {
    font-size: 30px;
    margin-bottom: 14px;
  }

  .stat-description {
    font-size: 16px;
    line-height: 1.7;
  }
}

@media (max-width: 480px) {
  .content-container {
    padding: 50px 16px;
  }

  .support-section {
    margin-bottom: 80px;
  }

  .section-subtitle {
    font-size: 15px;
    margin-bottom: 10px;
    letter-spacing: 0.8px;
  }

  .section-title {
    font-size: 28px;
    margin-bottom: 18px;
    line-height: 1.5;
  }

  .scalability-section .section-title {
    font-size: 28px;
    margin-bottom: 40px;
  }

  .section-description {
    font-size: 16px;
    line-height: 2;
    margin-bottom: 12px;
  }

  .stats-grid {
    gap: 30px;
  }

  .stat-number {
    font-size: 26px;
    margin-bottom: 12px;
  }

  .stat-description {
    font-size: 15px;
    line-height: 1.8;
  }
}

@media (max-width: 360px) {
  .content-container {
    padding: 40px 12px;
  }

  .section-subtitle {
    font-size: 14px;
  }

  .section-title {
    font-size: 24px;
  }

  .scalability-section .section-title {
    font-size: 24px;
  }

  .section-description {
    font-size: 15px;
  }

  .stat-number {
    font-size: 22px;
  }

  .stat-description {
    font-size: 14px;
  }
}
</style>
